import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "gfu-search-form-fields__search-button gfu-btn",
  "data-qa": "comments-streams-button:Search"
}
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "gfu-comment-streams__suggestions-wrapper" }
const _hoisted_4 = { "format-key": "0" }
const _hoisted_5 = ["onClick", "onKeydown", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["gfu-field gfu-comment-streams__search-input-container _mt-0", {'gfu-comment-streams__search-input-container--active': $data.isSelecting && !$data.isSearching}])
    }, [
      _createElementVNode("button", _hoisted_1, [
        _createVNode(_component_base_icon, { name: "search" })
      ]),
      _withDirectives(_createElementVNode("input", {
        ref: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.term) = $event)),
        placeholder: _ctx.Resources.Comments.SearchTagsFieldPlaceholder,
        type: "text",
        class: _normalizeClass(["gfu-field__input gfu-search-form-fields__input", { 'gfu-comment-streams__search-input--alt': $props.isMobile }]),
        name: "term",
        autocomplete: "off",
        "data-qa": "comments-streams-field:Search"
      }, null, 10 /* CLASS, PROPS */, _hoisted_2), [
        [_vModelText, $data.model.term]
      ]),
      _createElementVNode("button", {
        class: "gfu-search-form-fields__close-button gfu-btn",
        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.resetSearch && $options.resetSearch(...args)), ["stop","prevent"])),
        "data-qa": "comments-streams-button:ResetSearch"
      }, [
        _createVNode(_component_base_icon, { name: "times" })
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["gfu-comment-streams__suggestions", { 'gfu-comment-streams__suggestions--alt': $props.isMobile }]),
        "data-qa": "comments-streams-suggestions"
      }, [
        _createElementVNode("ul", null, [
          _withDirectives(_createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.onTagSelected($data.model.term)), ["prevent"])),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers($event => ($options.onTagSelected($data.model.term)), ["prevent"]), ["down"])),
            "data-qa": "comments-streams-suggestions:GoTo"
          }, [
            (_openBlock(), _createBlock(_component_localize, {
              key: $options.sanitizedTagSearchTerm,
              resource: _ctx.Resources.Comments.TagSearchGoToTagResult
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString($options.sanitizedTagSearchTerm), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"]))
          ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vShow, $options.isTermValidTag && !$options.searchTags.includes($options.sanitizedTagSearchTerm)]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.searchTags, (tag) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `tag-${tag}`,
              onClick: _withModifiers($event => ($options.onTagSelected(tag)), ["prevent"]),
              onKeydown: _withKeys(_withModifiers($event => ($options.onTagSelected(tag)), ["prevent"]), ["down"]),
              "data-qa": `comments-streams-suggestions:${tag}`
            }, " #" + _toDisplayString(tag), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_5))
          }), 128 /* KEYED_FRAGMENT */)),
          _withDirectives(_createElementVNode("li", {
            class: "gfu-comment-streams__suggestions--no-matches",
            "data-qa": "comments-streams-suggestions:NoMatches"
          }, _toDisplayString(_ctx.Resources.Comments.TagSearchNoMatchesResult), 513 /* TEXT, NEED_PATCH */), [
            [_vShow, !$options.searchTags.length]
          ])
        ])
      ], 2 /* CLASS */), [
        [_vShow, $data.isSelecting && !$data.isSearching]
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}